import { createStore, applyMiddleware }                 from 'redux'
import { composeWithDevTools }                          from 'redux-devtools-extension'
import thunkMiddleware                                  from 'redux-thunk'
import { createLogger }                                 from 'redux-logger'
import { ReferencesAppState, ReferencesReducer }        from './references'

export default function configureStore( preloadedState: ReferencesAppState ) {
    const loggerMiddleware = createLogger()
    let middleware = applyMiddleware(
        thunkMiddleware,
        loggerMiddleware,
    )
    middleware = composeWithDevTools( middleware );

    return createStore(
        ReferencesReducer,
        preloadedState,
        middleware
    )
}



/** WEBPACK FOOTER **
 ** C:/BIZJ/Code/Business/Flexxus/Flexxus.Web/Scripts/flexxus-references-app/src/store/configureStore.ts
 **/